import React from "react";
import "./Contact.css";
import { useState } from "react";
import axios from "axios";
import Forfmsubmit from "../Loader/Forfmsubmit"
import ManualAlertpage from "../Alert/ManualAlertpage";

const ApplyJob = () => {

  // form submission 

  const [submissionpage, setsubmissionpage] = useState(false); // for enable Submission page 
  const [Submissiondata, setSubmissiondata] = useState({})

  const toggleFn = () => {
    setsubmissionpage(!submissionpage);
  }

  const [error, seterror] = useState("")
  const [loader, setloader] = useState(false)

  const [Data, setData] = useState({
    fullname: "",
    number: "",
    email: "",
    department: "",
    jobtitle: "",
    experience: "",
    resume: null
  })

  const handlechange = (e) => {
    const { name, value } = e.target
    setData({
      ...Data,
      [name]: value
    })
  }

  const handleFileChange = (e) => {
    const file = e.target.files ? e.target.files[0] : null;  // Safe check

    if (file) {
      const { name } = e.target;
      // Set the selected file in the state (as a file object, not base64)
      setData({
        ...Data,
        [name]: file
      });

      setData((prevdata) => ({
        ...prevdata,
        resume: file
      }))
    } else {
      console.error("No file selected");
    }
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    setloader(true);

    try {
      seterror("");
      // Check if resume file is selected
      if (!Data.resume) {
        seterror("Please upload your resume");
        return;  // Stop further submission if file is missing
      }
      if (Data.number.length != 10) {
        seterror("Please fill number must in 10 digits")
        return
      }
      if (Data.experience == "") {
        seterror("please fill validate experience.")
        return
      }

      const formData = new FormData();

      formData.append("fullname", Data.fullname);
      formData.append("number", Data.number);
      formData.append("email", Data.email);
      formData.append("department", Data.department);
      formData.append("jobtitle", Data.jobtitle);
      formData.append("experience", Data.experience);

      if (Data.resume) {
        formData.append("resume", Data.resume);
      }
      const response = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/applyjob", {
        method: "POST",
        body: formData,
      });

      const result = await response.json()
      if (response.ok) {
        setsubmissionpage(true)
        setSubmissiondata({
          message: `Thank you for applying for the post of ${Data.jobtitle}.`,
          context: `A confirmation E-mail has been sent on <strong>${Data.email}</strong></strong>.`,
          context2: "After reviewing your application we will be in touch with you shortly.",
          btnname: "Ok"
        })
        setData({ fullname: "", number: "", email: "", department: "", jobtitle: "", experience: "", resume: null })

      } else {
        seterror("Error: " + result.message);
      }
    } catch (err) {
      seterror("Server is not giving response");
      console.error(err.message);
    } finally {
      setloader(false);
    }
  };


  if (loader) {
    return <Forfmsubmit />
  }

  return (
    <>
      <section className="apply-job">
        <div className="home-services-header">
          <h1 className="section-title">
            <span>Apply</span> Here
          </h1>
        </div>

        <div class="">

          <form className="form" action="POST" onSubmit={handlesubmit}>
            <input
              name="fullname"
              type="text"
              className="form-control"
              placeholder="Enter Full Name"
              value={Data.fullname}
              onChange={handlechange}
              required
            />

            <input
              name="email"
              type="email"
              className="form-control"
              placeholder="Enter Email"
              value={Data.email}
              onChange={handlechange}
              required
            />

            <input
              type="number"
              name="number"
              className="form-control"
              placeholder="Mobile Number"
              value={Data.number}
              onChange={handlechange}
              required
            />

            <select name="department" id="department" onChange={handlechange} value={Data.department} required>
              <option value="" disabled>Select Department</option>
              <option value="IT">IT</option>
              <option value="Finance">Finance</option>
              <option value="HR">HR</option>
              <option value="Trainer">Trainer</option>
              <option value="Sales/Marketing">Sales/Marketing</option>
            </select>

            <select title="Fill Job title" name="jobtitle" id="jobtitle" onChange={handlechange} value={Data.jobtitle} required>
              <option value="" disabled>Select Job Title</option>
              <option className="option" value="Web Designer">
                Web Designer
              </option>
              <option className="option" value="Web Developer">
                Web Developer
              </option>
              <option className="option" value="Business Development Executive">
                Business Development Executive
              </option>
            </select>

            <select name="experience" className="form-control" onChange={handlechange} value={Data.experience} required title="Fill your experince">
              <option value="" selected disabled>Fill Experince</option>
              <option value="0-1 Year">0-1 Years</option>
              <option value="1-2 Year">1-2 Years</option>
              <option value="2-3 Year">2-3 Years</option>
              <option value="3-4 Year">3-4 Years</option>
              <option value="4-5 Year">4-5 Years</option>
              <option value="5+ Year">5+ Years</option>
            </select>

            <input
              accept=".docx,.jpg,.png"
              type="file"
              name="resume"
              className="form-control mt-2"
              onChange={handleFileChange}
              title="Upload your resume"
              required
            />

            {error && <p className="error-textapply">{error}</p>}

            <button type="submit" aria-label="Create Account">
              Apply
            </button>
          </form>
        </div>
        {submissionpage &&
          <ManualAlertpage
            message={Submissiondata.message}
            context={Submissiondata.context}
            context2={Submissiondata.context2}
            btnname={Submissiondata.btnname}
            close={submissionpage}
            togglebox={toggleFn} />
        }
      </section>
    </>
  )
};

export default ApplyJob
